<template>
  <div class="optional-input">
    <p class="optional-hint">请选择并完成 {{ requiredCount }} 道子题</p>
    <section v-for="(subQuestion, index) in subQuestions" :key="subQuestion.id || index" :class="['optional-item', { 'is-selected': entry(index).selected }]">
      <label class="optional-selector">
        <CheckboxControl
          :checked="entry(index).selected"
          :disabled="disabled || selectionDisabled(index)"
          @change="select(index, $event)"
        />
        <strong>选做第 {{ index + 1 }} 小题</strong><span>{{ subQuestion.question_type_word }}</span>
      </label>
      <div class="optional-question" v-html="subQuestion.question"></div>
      <OptionList
        v-if="subQuestion.options.length"
        :value="entry(index).content"
        :options="subQuestion.options"
        :multiple="subQuestion.question_type === 2"
        :name="`${name}-optional-${index}`"
        :disabled="disabled || !entry(index).selected"
        @input="updateContent(index, $event)"
      />
      <textarea v-else :value="entry(index).content" rows="4" placeholder="请输入答案" :disabled="disabled || !entry(index).selected" @input="updateContent(index, $event.target.value)"></textarea>
    </section>
  </div>
</template>
<script>
import CheckboxControl from './CheckboxControl.vue'
import OptionList from './OptionList.vue'
export default { name: 'OptionalQuestionInput', components: { CheckboxControl, OptionList }, props: { value: { type: Array, default: () => [] }, subQuestions: { type: Array, default: () => [] }, requiredCount: { type: Number, default: 1 }, name: { type: String, default: '' }, disabled: { type: Boolean, default: false } }, methods: { entry(index) { return this.value[index] || { name: index + 1, selected: false, content: '' } }, selectionDisabled(index) { return !this.entry(index).selected && this.value.filter(item => item && item.selected).length >= this.requiredCount }, clone() { return this.value.map(item => ({ ...item, content: Array.isArray(item.content) ? [...item.content] : item.content })) }, select(index, selected) { const next = this.clone(); if (!next[index]) return; next[index].selected = selected; this.$emit('input', next) }, updateContent(index, content) { const next = this.clone(); if (!next[index]) return; next[index].content = content; this.$emit('input', next) } } }
</script>
<style scoped lang="scss">
@import '@/styles/tokens';
.optional-input, .optional-item { display: grid; gap: 12px; }
.optional-hint { margin: 0; color: $color-text-secondary; font-size: 13px; }
.optional-item { padding: 14px; border: 1px solid $color-border-light; border-radius: var(--radius-md); background: $color-background; }
.optional-item.is-selected { border-color: rgba($color-primary, 0.45); background: rgba($color-primary, 0.035); }
.optional-selector { display: flex; align-items: center; gap: 10px; color: $color-primary; }
.optional-selector span { color: $color-text-secondary; font-size: 13px; }
.optional-question { color: $color-text-primary; line-height: 1.7; }
textarea { width: 100%; resize: vertical; }
</style>
